import * as Types from '../../../graphql-types'

import { gql } from '@apollo/client'
export type ContentDetails_Person_ContentFragmentFragment = {
  __typename?: 'Content'
  id?: string | null
  title?: string | null
  language?: string | null
  contentType?: string | null
  contentId?: number | null
  published?: boolean | null
  avatar?: Array<{
    __typename?: 'ImageContentRelationship'
    id?: string | null
    type?: string | null
    image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
  } | null> | null
}

export type ContentDetails_Person_ContentReferenceFragmentFragment = {
  __typename?: 'ContentReference'
  id?: string | null
  sortKey?: number | null
  contentReferenceType?: {
    __typename?: 'ContentReferenceType'
    id?: string | null
    type?: string | null
  } | null
  contentTo?: Array<{
    __typename?: 'Content'
    id?: string | null
    title?: string | null
    language?: string | null
    contentType?: string | null
    contentId?: number | null
    published?: boolean | null
    avatar?: Array<{
      __typename?: 'ImageContentRelationship'
      id?: string | null
      type?: string | null
      image?: { __typename?: 'Image'; id?: string | null; url?: string | null } | null
    } | null> | null
  } | null> | null
}

export const ContentDetails_Person_ContentFragmentFragmentDoc = gql`
  fragment ContentDetails_Person_ContentFragment on Content {
    id
    title
    language
    contentType
    contentId
    published
    avatar: imageContentRelationships {
      id
      type
      image {
        id
        url
      }
    }
  }
`
export const ContentDetails_Person_ContentReferenceFragmentFragmentDoc = gql`
  fragment ContentDetails_Person_ContentReferenceFragment on ContentReference {
    id
    sortKey
    contentReferenceType {
      id
      type
    }
    contentTo {
      ...ContentDetails_Person_ContentFragment
    }
  }
  ${ContentDetails_Person_ContentFragmentFragmentDoc}
`
